(function($) {
	$(window).on('load', function() {
		$('.leftMenu__item').each(function() {
			var $block = $(this),
				$blockContent = $block.find('.leftMenuSub');

			if ($block.hasClass('active')) {
				$blockContent.animate({ opacity:1 }, { duration:500, queue:false });
				$blockContent.slideDown(500);
				$block.addClass('showContent');
			};
			$block.on('click', function() {
				if ($block.hasClass('showContent')) {
					$blockContent.stop().animate({ opacity:0 }, { duration:500, queue:false });
					$blockContent.slideUp(500);
					$block.removeClass('showContent');
				} else {
					$blockContent.stop().animate({ opacity:1 }, { duration:500, queue:false });
					$blockContent.slideDown(500);
					$block.addClass('showContent');
				}
			});
		});
	});
})(jQuery);